import { cn } from '@/lib/utils'

const initialsOf = (name?: string) =>
    (name || '?')
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase())
        .join('') || '?'

/** Iniciais num círculo — sem serviço externo de avatar. */
export const UserAvatar = ({ name, className }: { name?: string; className?: string }) => (
    <span
        aria-hidden="true"
        className={cn(
            'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-[11px] font-bold text-primary-foreground',
            className
        )}
    >
        {initialsOf(name)}
    </span>
)
